<div class="forbidden-view-page">
<div class="sc-header" *ngIf="!intoFaq">
    <div class="container">
        <img src="assets/images/logo-sc-azul.svg" alt="" class="logo">
        <div class="help">
            <a id="ayuda" (click)="goToFaq();"><span class="icon-question-elipse"></span> Ayuda</a>
        </div>
    </div>
</div>
<div class="container forbidden--page">
    <div class="row">
        <div class="col-md-5 col-xs-12">
            <h1 class="forbidden--title">La plataforma no está disponible</h1>
            <h3 class="forbidden--subtitle">Tu sesión expiró u ocurrió un error inesperado.</h3>
            <div class="forbidden--background">
                <sc-button-2 id="btn_continuar_backportal"
                           type="btn-primary forbidden-button"
                           body="Volver a ingresar"
                           (onClick)="goTo($event)">
                </sc-button-2>
            </div>
        </div>
        <div class="col-md-7 col-xs-12 mobile-hidden">
            <img src="assets/images/img-timeout-01.png" alt="Timeout">
        </div>
    </div>
</div>
<div class="container forbidden--margintop">
    <div class="row forbidden--message">
        <div class="col-md-12 col-xs-12">
            <p class="forbidden--number_description mobile-hidden">Si el problema persiste comunicate con tu sucursal o con nuestro centro de soporte para más información.</p>
            <p class="forbidden--number_description desktop-hidden">Si el problema persiste comunicate con tu sucursal o con nuestro centro de soporte para más información.</p>
        </div>
    </div>
</div>
</div>
